import React from "react";

const CPP_String = () => {
  return (
    <div>
      <h1>CPP_String Component</h1>
      <p>Content for CPP_String goes here...</p>
    </div>
  );
};

export default CPP_String;
